<template>
  <v-dialog v-if="!no_data.includes(item)" v-model="dialog" max-width="500px" persistent>
    <v-card class="pa-3">
      <v-card-title>
        <h2 class="title">Edit Alternative Text</h2>
      </v-card-title>

      <v-card-text class="mt-5">
        <div>
          <v-text-field
              v-model="preparedData.alt_text"
              name="alt_text"
              id="alt_text"
              label="Alternative"
              persistent-hint
              placeholder="Please Enter"
              :error-messages="errors($v.preparedData.alt_text) || server_errors.alt_text"
              @focus="resetServerValidation"
          ></v-text-field>
          <v-alert class="pa-2 mt-6" :value="$v.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
            <span class="caption">Please fill out form correctly</span>
          </v-alert>
          <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                   transition="scale-transition">
            <span class="caption">{{ serverValidationMessage }}</span>
          </v-alert>
        </div>
      </v-card-text>

      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeEditAltText">Cancel</v-btn>
        <v-btn
            color="primary"
            :disabled="loading"
            :loading="loading"
            @click="editAltText"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/common/api.service";
import { validationMixin } from "vuelidate"
import { required, maxLength } from "vuelidate/lib/validators"
import {valMessages, getValMessage} from "@/common/error-messages"

let validations = {}

export default {
  name: 'EditAltText',
  mixins: [validationMixin],
  validations() {
    validations = {
      preparedData: {
        alt_text: { txtMaxLen: maxLength(125) }
      }
    }
    this.errors = getValMessage(valMessages)(validations)
    return validations
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    item: null,
    preparedData: {},
    loading: false,
    dialog: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  mounted() {
    this.$root.$on('EditAltText', this.openModal)
  },
  beforeDestroy() {
    this.$root.$off('EditAltText', this.openModal)
  },
  methods: {
    openModal(inputData) {
      this.resetServerValidation()
      this.$v.$reset()
      this.item = _.cloneDeep(inputData)
      this.preparedData = {
        alt_text: this.item.alt_text
      }
      this.dialog = true
    },
    editAltText() {
      this.resetServerValidation()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let body = {
          organization_id: this.$route.params.organization_id,
          alt_text: this.preparedData.alt_text
        }
        ApiService.put(`/admin/banner/${this.item.id}/alt_text`, body)
          .then(response => {
            this.$root.$emit("notification", {
              status: "success",
              text: `Action has been completed successfully.`
            });
            this.loading = false
            this.$emit('done')
            this.closeEditAltText()
          })
          .catch(({response}) => {
            this.loading = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(
                  response.data.error
              );
            }
            if (response.data.message) {
              this.serverValidationMessage = response.data.message;
            }
            if (response.data.errors) {
              this.server_errors = response.data.errors;
            }
          });
      }
    },
    closeEditAltText() {
      this.dialog = false
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    },
    errors: getValMessage(valMessages)(validations)
  }
}
</script>
